var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './InfoMessage.module.scss';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
export var E_INFO_MESSAGE_SEVERITY;
(function (E_INFO_MESSAGE_SEVERITY) {
    E_INFO_MESSAGE_SEVERITY["ERROR"] = "ERROR";
    E_INFO_MESSAGE_SEVERITY["WARNING"] = "WARNING";
    E_INFO_MESSAGE_SEVERITY["SUCCESS"] = "SUCCESS";
    E_INFO_MESSAGE_SEVERITY["INFO"] = "INFO";
})(E_INFO_MESSAGE_SEVERITY || (E_INFO_MESSAGE_SEVERITY = {}));
export var InfoMessage = function (props) {
    var _a;
    var severity = props.severity, messages = props.messages, children = props.children, className = props.className;
    var getIcon = function () {
        switch (severity) {
            case E_INFO_MESSAGE_SEVERITY.INFO:
                return E_ICONS.INFO;
            case E_INFO_MESSAGE_SEVERITY.ERROR:
                return E_ICONS.CLOSE;
            case E_INFO_MESSAGE_SEVERITY.WARNING:
                return E_ICONS.WARNING;
            case E_INFO_MESSAGE_SEVERITY.SUCCESS:
                return E_ICONS.CHECK;
        }
    };
    var infoMessageClass = classNames(styles.InfoMessageWrapper, className, (_a = {},
        _a[styles.info] = severity === E_INFO_MESSAGE_SEVERITY.INFO,
        _a[styles.error] = severity === E_INFO_MESSAGE_SEVERITY.ERROR,
        _a[styles.warning] = severity === E_INFO_MESSAGE_SEVERITY.WARNING,
        _a[styles.valid] = severity === E_INFO_MESSAGE_SEVERITY.SUCCESS,
        _a));
    var icon = getIcon();
    var isMessagesArray = Array.isArray(messages);
    return (_jsxs("div", __assign({ className: infoMessageClass }, { children: [_jsx(Icons, { icon: icon, className: styles.InfoMessageIcon }), _jsxs("div", __assign({ className: styles.InfoMessagesWrapper }, { children: [messages ? (isMessagesArray ? (messages.map(function (message) { return (_jsx(_Fragment, { children: _jsx("p", { children: message }, message) })); })) : (_jsx("p", { children: messages }))) : null, children] }))] })));
};
